<template>
    <div class="py-4">
        <h4 class="mb-4 pb-4 text-center font-active">Shop By Metal</h4>
        <!-- :slidesPerView="4"
            :loopAdditionalSlides="3"
        -->
        <swiper
        :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
        }" 
            :loop="true" 
            :modules="[SwiperAutoplay]" 
            :breakpoints="{
                0 : {
                    slidesPerView: 1.7,
                    centeredSlides: true,
                    slidesPerGroup: 1,
                },       
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
                1300: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                },                
            }"
            
            class="mySwiper"
            >
                <swiper-slide>
                    <div class="slide_box">
                        <picture>
                        <source width="280" height="280" type="image/webp" srcset="~/assets/metals/white.webp">
                        <img loading="lazy" width="280" height="280" type="image/jpeg" alt="White Gold" src="~/assets/metals/white.jpg">
                        </picture>
                        <div class="metal_text">
                            <div class="wrap_content">
                            <h3 class="font-active">White Gold </h3>
                            <p >White gold, available in 14KT and 18KT, is one of the most popular metal choices for lab grown engagement rings due to its lasting durability and shiny platinum-like lustre.</p>
                            <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'white-gold-engagement-rings' } })">Shop </NuxtLink>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                
                <swiper-slide>
                    <div class="slide_box">
                        <picture>
                        <source width="280" height="280" type="image/webp" srcset="~/assets/metals/yellow.webp">
                        <img loading="lazy" width="280" height="280" type="image/jpeg" alt="Yellow Gold" src="~/assets/metals/yellow.jpg">
                        </picture>
                        <div class="metal_text">
                            <div class="wrap_content">
                            <h3 class="font-active">Yellow Gold </h3>
                            <p>Yellow gold, available in 14KT and 18KT, adds a traditional and classic touch to engagement rings and pairs well with darker skin tones to provide an eye-catching contrast. </p>
                            <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'yellow-gold-engagement-rings' } })">Shop</NuxtLink>
                            </div>
                        </div>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="slide_box">
                        <picture>
                        <source width="280" height="280" type="image/webp" srcset="~/assets/metals/rose.webp">
                        <img loading="lazy" width="280" height="280" type="image/jpeg" alt="Rose Gold" src="~/assets/metals/rose.jpg">
                        </picture>
                        <div class="metal_text">
                            <div class="wrap_content">
                            <h3 class="font-active">Rose Gold </h3>
                            <p>Rose gold, available in 14KT and 18KT, is a subtle and exquisite metal that adds a feminine charm to all ring styles including traditional, modern, and vintage designs.</p>
                            <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'rose-gold-engagement-rings' } })">Shop</NuxtLink>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <picture>
                        <source width="280" height="280" type="image/webp" srcset="~/assets/metals/platinum.webp">
                        <img loading="lazy" width="280" height="280" type="image/jpeg" alt="Platinum" src="~/assets/metals/platinum.jpg">
                        </picture>
                        <div class="metal_text">
                            <div class="wrap_content">
                            <h3 class="font-active">Platinum </h3>
                            <p>Platinum, known for its purity, has a beautiful white reflective appearance and is resistant to tarnish and corrosion, making it one of the most desirable metals for modern couples.</p>
                            <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'platinum-engagement-rings' } })">Shop</NuxtLink>
                        </div>
                        </div>
                    </div>
                </swiper-slide>

        </swiper>
    </div>
</template>

<script setup>
const localePath = useLocalePath()

</script>

<style scoped>
 /* Commented out display none in media queries 512px */
h4{
    font-size: 30px;
    
}
.slide_box{
    padding: 0 4%;
    text-align: center;
}

.slide_box img{
    margin: 0 auto;
}
.metal_text {
    /* max-width: 280px; */
    padding: 6% 0;
}

.metal_text h3 {
    font-size: 24px;
   
}

.metal_text p {
    color: #6a6161;
    font-size: 16px;
    padding: 3% 0;
}

.metal_text a {
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 9px 25px;
    width: 100%;
    text-align: center;
    border-radius: 4px;
}
@media(max-width: 992px){
    .metal_text h3{
        font-size: 22px;
    }
    .slide_box {
        text-align: center;
    }
    img{
        margin: 0 auto;
    }
    .metal_text {
        margin: 0 auto;
    }
}
@media(max-width: 767px){
    h4{
        font-size: 24px;
    }
}
@media(max-width: 512px){
  
    .metal_text {
        max-width: 100%;
        text-align: center;
       /* display: none; */
    }
    img{
        margin: 0 auto;
    }
    
    /* .slick-slide.slick-active.slick-center.slick-current  .metal_text  {
        display: block;
    } */

    .swiper-slide .wrap_content {
        display: none;
    }

    .swiper-slide-active .wrap_content {
        display: block ;
    }
}
</style>